import { rootStore } from '../store/Root.store';

enum protocols {
    http = 'http',
    https = 'https',
}

type protocol = `${protocols}`;

enum statuses {
    success = 'success',
    error = 'error',
}

interface IDefaultRes {
    result: statuses;
    info: string[];
    activate: boolean;
}

type IRes<T = {}> = IDefaultRes & T;

interface IConfig {
    encryption: boolean;
    host: string;
    port: number;
}

export default class AbstractAPI {
    public _path: string;
    public _headers = {
        'Content-Type': 'application/json',
    };

    _checkAuth(data: IDefaultRes) {
        const { result, info } = data;
        if (result === 'error' && info && info.indexOf('not_auth') >= 0) {
            localStorage.setItem('token', '');
            rootStore.setDefault();
            rootStore.app.resetDemoMode();
        }
    }

    _getPortStr(portNumber: number, protocol: protocol) {
        const httpDefault = 80;
        const httpsDefault = 443;
        const isHttpDefault = protocol === 'http' && portNumber === httpDefault;
        const isHttpsDefault =
            protocol === 'https' && portNumber === httpsDefault;
        return isHttpDefault || isHttpsDefault ? '' : `:${portNumber}`;
    }

    _getUrl(pathname: string) {
        const regExp = /^\/.*$/;
        const isValid = regExp.test(pathname);
        if (!isValid) pathname = `/${pathname}`;
        return `${this._path}${pathname}`;
    }

    async _request<T extends object = {}>(
        pathname: string,
        method: string,
        bodyObject?: object,
        corsMode?: string,
        contentType?: string,
    ): Promise<IRes<T>> {
        const url = this._getUrl(pathname);
        const headers = this._headers;
        if (contentType) headers['Content-Type'] = contentType;
        let mode = 'cors';
        if (corsMode) mode = corsMode;
        let body;
        if (bodyObject) body = JSON.stringify(bodyObject);
        try {
            const res = await fetch(url, {
                method,
                headers,
                mode: mode as RequestMode,
                body,
            });
            if (headers['Content-Type'] === 'application/json') {
                const data = await res.json();                                
                if (
                    data.result === 'error' &&
                    data.info &&
                    data.info.indexOf('not_auth') >= 0
                )
                    localStorage.setItem('token', '');
                this._checkAuth(data);       
                return data;
            } else return (await res.text()) as any;
        } catch (e) {
            throw new Error(e);
        }
    }
    async _requestOldLogin<T extends object = {}>(
        pathname: string,
        method: string,
        bodyObject?: object,
        corsMode?: string,
        contentType?: string,
    ): Promise<IRes<T>> {
        const url = this._getUrl(pathname);        
        const headers = this._headers;
        if (contentType) headers['Content-Type'] = contentType;
        let mode = 'cors';
        if (corsMode) mode = corsMode;
        let body;
        if (bodyObject) body = JSON.stringify(bodyObject);
        try {
            const res = await fetch(url, {
                method,
                headers,
                mode: mode as RequestMode,
                body,
            });
            if (headers['Content-Type'] === 'application/json') {
                const data = await res.json();                
                if (
                    data.result === 'error' &&
                    data.info &&
                    data.info.indexOf('not_auth') >= 0
                )
                    localStorage.setItem('token', '');
                return data;
            } else return (await res.text()) as any;
        } catch (e) {
            throw new Error(e);
        }
    }

    constructor(config: IConfig) {
        const { encryption, host, port } = config;
        const protocol = encryption ? 'https' : 'http';
        const portStr = this._getPortStr(port, protocol);
        this._path = `${protocol}://${host}${portStr}`;
    }
}
